import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  About,
  Careers,
  Contact,
  Home,
  MakingMindsLearning,
  NewsLetterSubscribe,
  PosterDesigns,
  PosterMaking,
  Pricing,
  PrivacyPolicy,
  Products,
  Service,
  TermsAndCondition,
  WebsiteDevelopment,
  WebsiteMPackage,
  WebsiteMaintaince,
  CookiePolicy,
  WorkspaceMakingMinds,
  Certifications
} from './route';
import PublicLayout from './pages/PublicLayout';
import Page404 from './components/Page404/Page404';
import Events from './Events/Events';

function App() {
  return (
    <BrowserRouter>

      <Routes>
        <Route path="" element={<PublicLayout />}>
          <Route exact path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
          <Route exact path={`${process.env.PUBLIC_URL}/home`} element={<Home />} />
          <Route exact path={`${process.env.PUBLIC_URL}/about`} element={<About />} />
          <Route exact path={`${process.env.PUBLIC_URL}/pricing`} element={<Pricing />} />
          {/* {SERVICES} */}
          <Route exact path={`${process.env.PUBLIC_URL}/websitedevelopment`} element={<WebsiteDevelopment />} />
          <Route exact path={`${process.env.PUBLIC_URL}/websitemaintaince`} element={<WebsiteMaintaince />} />
          <Route exact path={`${process.env.PUBLIC_URL}/posterdesigns`} element={<PosterDesigns />} />
          {/* {PACKAGE} */}
          <Route exact path={`${process.env.PUBLIC_URL}/websitemaintaincepackage`} element={<WebsiteMPackage />} />
          <Route exact path={`${process.env.PUBLIC_URL}/postermaking`} element={<PosterMaking />} />
          {/* {LEGAL} */}
          <Route exact path={`${process.env.PUBLIC_URL}/legal/privacy-policy`} element={<PrivacyPolicy />} />
          <Route exact path={`${process.env.PUBLIC_URL}/legal/terms-conditions`} element={<TermsAndCondition />} />
          <Route exact path={`${process.env.PUBLIC_URL}/legal/cookie-policy`} element={<CookiePolicy />} />



          <Route exact path={`${process.env.PUBLIC_URL}/makingminds/careers`} element={<Careers />} />
          <Route exact path={`${process.env.PUBLIC_URL}/service`} element={<Service />} />
          <Route exact path={`${process.env.PUBLIC_URL}/makingminds/newsletter`} element={<NewsLetterSubscribe />} />
          <Route exact path={`${process.env.PUBLIC_URL}/makingminds/products`} element={<Products />} />
          <Route exact path={`${process.env.PUBLIC_URL}/makingminds/certification`} element={<Certifications />} />





        </Route >
        {/* Making Minds Technologies Learning and certification */}
        <Route exact path={`${process.env.PUBLIC_URL}/makingminds/training`} element={<MakingMindsLearning />} />
        {/* Events */}
        <Route exact path={`${process.env.PUBLIC_URL}/makingminds/events`} element={<Events />} />
        {/* Workspace */}
        <Route exact path={`${process.env.PUBLIC_URL}/makingminds/workspace`} element={<WorkspaceMakingMinds />} />
        {/* Contact */}
        <Route exact path={`${process.env.PUBLIC_URL}/contact`} element={<Contact />} />




        {/* Error 404 Page */}
        <Route path="*" element={<Page404 />} />
        {/* Error 404 Page */}





      </Routes>

    </BrowserRouter>
  );
}

export default App;
